const hasCCMEmbedding = (embeddingName: string) => {
  const embedding = window.CCM?.acceptedEmbeddings?.find(
    (embedding: { name: string; id: string }) => {
      return embedding.name === embeddingName;
    }
  );

  return !!embedding;
};

export { hasCCMEmbedding };
